import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { IonicPage, LoadingController, MenuController, NavController, NavParams, ToastController } from 'ionic-angular';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
import { UserModel } from '../../models/user/user';
import { AuthProvider } from '../../providers/auth/auth';
import { AppVersionProvider } from './../../providers/app-version/app-version';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  public loginData: FormGroup;
  user: UserModel;
  passwordInput: string = 'password';
  hideShowIcon: string = 'md-eye-off';
  language: string = 'id';

  type: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public menuCtrl: MenuController,
    public storage: Storage,
    public formBuilder: FormBuilder,
    public authPrvdr: AuthProvider,
    public translateSvc: TranslateService,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    public appVersionPrvdr: AppVersionProvider
  ) {
    this.appVersionPrvdr.getType().then((type) => {
      this.type = type;
    });
    this.loginData = this.formBuilder.group({
      username: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
    });
  }

  ionViewDidLoad() {
    this.menuCtrl.enable(false);
    this.initTranslate();
  }

  initTranslate(): void {
    this.translateSvc.setDefaultLang('id');

    this.translateSvc.use('id');
    moment.locale('id');
    this.language = 'id';
  }

  onChangeLanguage(language): void {
    this.translateSvc.use(language);
    moment.locale(language);
  }

  onLogin() {
    let loading = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: 'Logging in...',
    });
    loading.present();

    this.authPrvdr
      .login(this.loginData.value)
      .pipe(finalize(() => loading.dismiss()))
      .subscribe(
        () => {},
        (err) => this.handleError(err)
      );
  }

  hideShowPassword() {
    this.passwordInput = this.passwordInput === 'text' ? 'password' : 'text';
    this.hideShowIcon = this.hideShowIcon === 'md-eye-off' ? 'md-eye' : 'md-eye-off';
  }

  handleError(error: any) {
    let message: string;
    if (error.status && error.status === 401) {
      message = 'Login failed';
    } else {
      message = `Unexpected error: ${error.statusText}`;
    }

    const toast = this.toastCtrl.create({
      message,
      duration: 5000,
      position: 'bottom',
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts